module.exports = __webpack_public_path__ + "abe10453735f9d857a59e724577be565.MP3";